import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';

interface PostSignAcceptableUsePolicyUrlProps {
    id: string;
    token: string;
}

export const postSignAcceptableUsePolicy: MutationFunction<
    AxiosResponse<any>,
    PostSignAcceptableUsePolicyUrlProps
> = async (props: PostSignAcceptableUsePolicyUrlProps) => {
    const { id, token } = props;
    const headers = getDefaultHeaders(token);
    const signAcceptableUsePolicyUrl = `/acceptableusesignature/${id}`;

    return axiosInstance().post(
        signAcceptableUsePolicyUrl,
        {},
        withHeaders(headers)
    );
};

export const useSignAcceptableUsePolicy = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostSignAcceptableUsePolicyUrlProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postSignAcceptableUsePolicy, {
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to sign acceptable use policy';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
